import { Grid, Typography } from "@mui/material";
import { useAppSelector } from "app/hooks";
import { useMessage } from "hooks/intl";
import { selectCurrentStoreData } from "reduxState/currentStoreData/currentStoreDataSlice";
import { TierDetailsType } from "types/tierSets";
import { useStyles } from "./styles";

interface Props {
  tier: TierDetailsType;
  isExpandedView: boolean;
}

export const Tier = ({ tier, isExpandedView }: Props) => {
  const classes = useStyles();
  const { message } = useMessage();
  const { currency } = useAppSelector(selectCurrentStoreData);
  const isTierActive = tier.active;

  const prepareConditionInputName = (
    attribute: string,
    wallet?: string,
    event?: string,
  ) => {
    switch (attribute) {
      case "activeUnits":
        return `${message({ id: "activeUnits" })} (${wallet})`;
      case "totalEarnedUnits":
        return `${message({ id: "totalEarnedUnitsConst" })} (${wallet})`;
      case "numberOfCustomEvents":
        return `${message({ id: "numberOf" })} ${event}`;
      case "monthsSinceJoiningProgram":
        return message({ id: "monthsSinceJoiningTheProgram" });
      case "totalSpending":
        return `${message({ id: "totalSpendingWithCurrency" }, { currency })}`;
      case "cumulatedEarnedUnits":
        return `${message({ id: "cumulativeEarnedUnits" })} (${wallet})`;
      default:
        return message({ id: attribute });
    }
  };

  return (
    <div
      className={`${classes.tier} ${isTierActive ? "" : classes.inactiveTier}`}
    >
      <Typography className={classes.tierName}>{tier.name}</Typography>
      <Grid container gap={8} className={classes.tierWrapper}>
        {tier.conditions.map((condition, index) => {
          return (
            <Grid
              key={`${condition.attribute}-${index}`}
              item
              xs={isExpandedView ? 2.4 : 4}
            >
              <div className={classes.condition}>
                <span className={classes.conditionAttribute}>
                  {prepareConditionInputName(
                    condition.attribute,
                    condition.walletType,
                    condition.eventName,
                  )}
                </span>
                <span className={classes.conditionValue}>
                  {condition.value}
                </span>
              </div>
            </Grid>
          );
        })}
      </Grid>
    </div>
  );
};
